const Hashicorp = () => (
  <img alt="Hashicorp logo" src="/img/customer-logos/hashicorp-logo-white.svg" />
);

export default Hashicorp;
